import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, delay, of, switchMap} from 'rxjs';
import {AppConfigService} from '../../../common/service/app-config.service';
import {currentPlan} from '../inner-component.model';

export interface ULRInfo {
    url: string;
    uuid: string;
}

@Injectable({
    providedIn: 'root'
})
export class NlrpDashboardResultService {
    constructor(
        private http: HttpClient,
        private appConfigService: AppConfigService
    ) {}

    loadPlan(planSelected: currentPlan): Observable<any> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/plans/lodgement/loadPlan/' + planSelected.planLodgementId;
        return this.http.get<any>(url);
    }

    signedUrlForRetrieval(uidWithPrefix: string): Observable<ULRInfo> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/attachment/signedUrlForRetrieval' + uidWithPrefix;
        return this.http.get<ULRInfo>(url);
    }

    previewPdf(url: ULRInfo): Observable<ArrayBuffer> {
        return this.http.get(url.url, {responseType: 'arraybuffer'});
    }

    assign(userName, assignedToName, planLodgementId): Observable<{}> {
        planLodgementId = parseInt(planLodgementId);
        return this.http
            .post(`${this.appConfigService.settings.apiGatewayUrl}/plans/lodgement/assignUser`, {
                planLodgementId: planLodgementId,
                assignedTo: userName,
                assignedToName: assignedToName
            })
            .pipe(
                //TO-DO: It is test-purpose delay to check the progress bar action. It needs to be deleted when backend is ready
                delay(500),
                switchMap(res =>
                    //TO-DO: It needs to be tested when backend is ready
                    //vm.updateModel(JSOG.decode(res.data))
                    of({})
                )
            );
    }
}
